import axios from 'axios';

export const getEmailSchedule = async (reportId) => {
  // This endpoint returns 404 when no schedule exists yet. Treat that as a normal "not configured" state.
  const response = await axios.get(`/api/reports/${reportId}/email-schedule`, {
    validateStatus: (status) => (status >= 200 && status < 300) || status === 404,
  });
  if (response.status === 404) return null;
  return response.data;
};

export const createEmailSchedule = async ({ reportId, ...payload }) => {
  const { data } = await axios.post(`/api/reports/${reportId}/email-schedule`, payload);
  return data;
};

export const updateEmailSchedule = async ({ reportId, ...payload }) => {
  const { data } = await axios.patch(`/api/reports/${reportId}/email-schedule`, payload);
  return data;
};

export const deleteEmailSchedule = async (reportId) => {
  // Internal API returns 204 No Content on delete.
  await axios.delete(`/api/reports/${reportId}/email-schedule`);
  return null;
};

export const toggleEmailSchedule = async ({ reportId, isActive }) => {
  const { data } = await axios.post(`/api/reports/${reportId}/email-schedule/toggle`, { isActive });
  return data;
};

export const sendEmailScheduleNow = async (reportId) => {
  const { data } = await axios.post(`/api/reports/${reportId}/email-schedule/send`);
  return data;
};

export const testSendEmailSchedule = async (reportId) => {
  const { data } = await axios.post(`/api/reports/${reportId}/email-schedule/test-send`);
  return data;
};

export const getEmailScheduleSends = async ({ reportId, status, limit, offset }) => {
  const params = {};
  if (status) params.status = status;
  if (limit) params.limit = limit;
  if (offset) params.offset = offset;
  const { data } = await axios.get(`/api/reports/${reportId}/email-schedule/sends`, { params });
  return data;
};

export const getEmailSchedulesList = async ({ activeOnly, limit, offset } = {}) => {
  const params = {};
  if (typeof activeOnly === 'boolean') params.activeOnly = activeOnly;
  if (limit != null) params.limit = limit;
  if (offset != null) params.offset = offset;
  const { data } = await axios.get('/api/report-email-schedules', { params });
  return data;
};
